import { render } from "./HasAdminRole.vue?vue&type=template&id=49a28e19&ts=true"
import script from "./HasAdminRole.vue?vue&type=script&lang=ts"
export * from "./HasAdminRole.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__